import list from "../../styles/list.module.css";
import img1 from "../../assets/images/sub_text01.png";
import img2 from "../../assets/images/sub_text02.png";
import img3 from "../../assets/images/sub_text03.png";
import img4 from "../../assets/images/sub_text04.png";
import { useState, useRef } from "react";
import ListContent from "./detail/ListContent";
import { useEffect } from "react";
import {
  BiSolidUpArrow,
  BiSolidDownArrow,
  BiSolidLeftArrow,
  BiSolidRightArrow,
} from "react-icons/bi";
import SwiperCore, {
  Virtual,
  Navigation,
  Pagination,
  History,
  Grid,
} from "swiper/modules";
import { Swiper, SwiperSlide } from "swiper/react";
import styled from "styled-components";
// Import Swiper styles
import "swiper/css";
import "swiper/css/pagination";
import "swiper/css/navigation";
import { CommonAxios } from "../CommonAxios";
import { useSelector } from "react-redux";
import { useNavigate } from "react-router-dom";
import Swal from "sweetalert2";
import axios from "axios";
const ListWrap = () => {
  const { user } = useSelector(({ user }) => ({
    user: user.user,
  }));
  const [oneSelect, setOneSelect] = useState(true);
  const [twoSelect, setTwoSelect] = useState(false);
  const [threeSelect, setThreeSelect] = useState(false);

  const [data1, setData1] = useState([]);
  const [select, setSelect] = useState("");
  const [category, setCategory] = useState([]);
  const navigation = useNavigate();
  const [sw, setSw] = useState(false);

  useEffect(() => {
    const getToken = () => {
      const url = process.env.REACT_APP_HOSTDONAME + "/api/tokenEnd";

      const config = {
        headers: {
          Accept: "application/json",
          "Content-Type": "x-www-form-urlencoded",
        },
      };
      const FAIL = "쿠키가 삭제되었습니다.";
      axios.post(url, config).then((res) => {
        if (res.data.messageinfo.message === FAIL) {
          Swal.fire({
            title: "로그인 만료",
            text: "초기 페이지로 이동합니다.",
            allowOutsideClick: false,
            icon: "warning",
            confirmButtonColor: "#3085d6",
            confirmButtonText: "확인",
          }).then((res) => {
            if (res.isConfirmed) {
              localStorage.removeItem("digibooktoken");
              document.location.href = "/";
            }
          });
        } else {
          // dispatch(getAdminLesson(sendData));
        }
      });
    };
    const getToken2 = () => {
      const url = process.env.REACT_APP_HOSTDONAME + "/api/tokenEnd2";

      const config = {
        headers: {
          Accept: "application/json",
          "Content-Type": "x-www-form-urlencoded",
        },
      };
      const FAIL = "쿠키가 삭제되었습니다.";
      axios.post(url, config).then((res) => {
        if (res.data.messageinfo.message === FAIL) {
          Swal.fire({
            title: "로그인 만료",
            text: "초기 페이지로 이동합니다.",
            allowOutsideClick: false,
            icon: "warning",
            confirmButtonColor: "#3085d6",
            confirmButtonText: "확인",
          }).then((res) => {
            if (res.isConfirmed) {
              localStorage.removeItem("digibooktoken");
              document.location.href = "/";
            }
          });
        } else {
          // dispatch(getAdminLesson(sendData));
        }
      });
    };
    if (localStorage.getItem("digibooktoken")) {
      if (user.check === "Y") {
        getToken();
      }
      if (user.check === "N") {
        getToken2();
      }
      if (!user.check) {
        getToken2();
      }
    }

    return () => {
      // dispatch(adminLessonReset());
    };
  }, []);

  useEffect(() => {
    if (user) {
      if (sessionStorage.getItem("7434DA3SSd")) {
        let sendData = {
          category_project_no: sessionStorage.getItem("7434DA3SSd"),
        };

        CommonAxios(
          process.env.REACT_APP_HOSTDONAME + "/api/select_main_list",
          sendData,
          function (result) {
            if (result.messageinfo.state === "ok") {
              setData1(result.messageinfo.message);
              setCategory(result.messageinfo.message_data2);
              setSelect(sessionStorage.getItem("7434DA3SSd"));
              setRightColor(result.messageinfo.message_data2[0].no);
              setSw(true);
            } else {
            }
          }
        );
      } else {
        let sendData = {
          category_project_no: "",
        };

        CommonAxios(
          process.env.REACT_APP_HOSTDONAME + "/api/select_main_list_if",
          sendData,
          function (result) {
            if (result.messageinfo.state === "ok") {
              setData1(result.messageinfo.message);
              setCategory(result.messageinfo.message_data2);
              setSelect(result.messageinfo.message[0].no);
              setRightColor(result.messageinfo.message_data2[0].no);
              setSw(true);
            } else {
            }
          }
        );
        // setSelect("one");
      }
    } else {
      navigation("/");
    }
  }, [select]);

  const selectItem = (data) => {
    sessionStorage.setItem("7434DA3SSd", data);
    setSelect(data);
  };

  const prevRef = useRef(null);
  const nextRef = useRef(null);

  const [swiper, setSwiper] = useState(null);
  const [mainImageIndx, setMainImageIndx] = useState(0);
  const parmss = {
    navigation: {
      prevEl: prevRef.current,
      nextEl: nextRef.current,
    },
    onBeforeInit: (swiper) => {
      swiper.params.navigation.prevEl = prevRef.current;
      swiper.params.navigation.nextEl = nextRef.current;

      swiper.activeIndex = mainImageIndx;
      swiper.navigation.update();
    },
    onSwiper: setSwiper,
    onSlideChange: (e) => setMainImageIndx(e.activeIndex),
  };

  const prevRef1 = useRef(null);
  const nextRef1 = useRef(null);

  const [swiper1, setSwiper1] = useState(null);
  const [mainImageIndx1, setMainImageIndx1] = useState(0);
  const parmss1 = {
    navigation: {
      prevEl: prevRef1.current,
      nextEl: nextRef1.current,
    },
    onBeforeInit: (swiper) => {
      swiper.params.navigation.prevEl = prevRef1.current;
      swiper.params.navigation.nextEl = nextRef1.current;

      swiper.activeIndex = mainImageIndx1;
      swiper.navigation.update();
    },
    onSwiper: setSwiper1,
    onSlideChange: (e) => setMainImageIndx1(e.activeIndex),
  };

  const SwiperItem = ({ data }) => {
    return (
      <li>
        <svg
          xmlns="http://www.w3.org/2000/svg"
          width="200"
          height="182.408"
          viewBox="0 0 200 182.408"
        >
          <g
            id="패스_1739"
            data-name="패스 1739"
            transform="translate(-120.582 -285.617)"
            fill={Number(select) === data.no ? "#fff23f" : "#fff"}
            stroke-linecap="round"
            stroke-linejoin="round"
          >
            <path
              d="M 220.27099609375 465.5249938964844 C 214.2313690185547 465.5249938964844 208.3103637695312 463.9039001464844 203.1481628417969 460.8369445800781 C 198.1338043212891 457.8578491210938 193.9557800292969 453.6041259765625 191.0657501220703 448.53564453125 L 190.0460815429688 446.7473754882812 L 188.0953826904297 447.4049987792969 C 184.6251068115234 448.5748596191406 181.0115356445312 449.1679992675781 177.3549957275391 449.1679992675781 C 172.8173370361328 449.1679992675781 168.4166717529297 448.2798461914062 164.2752990722656 446.5281372070312 C 160.2739410400391 444.835693359375 156.6798400878906 442.4122924804688 153.5927734375 439.3252258300781 C 150.5057220458984 436.2381896972656 148.0823059082031 432.64404296875 146.3898620605469 428.6426696777344 C 144.6381683349609 424.5013122558594 143.75 420.1006774902344 143.75 415.56298828125 C 143.75 413.8818969726562 143.8772583007812 412.183837890625 144.128173828125 410.5159606933594 L 144.4080352783203 408.6559143066406 L 142.6983337402344 407.8716430664062 C 136.9272766113281 405.2244873046875 132.0341949462891 401.0116271972656 128.5480346679688 395.6884460449219 C 124.9721145629883 390.228271484375 123.0820007324219 383.876220703125 123.0820007324219 377.3190002441406 C 123.0820007324219 370.7326965332031 124.9875259399414 364.3570556640625 128.5925903320312 358.88134765625 C 132.1080017089844 353.5417785644531 137.0374755859375 349.3290100097656 142.8480529785156 346.6984558105469 L 144.6182556152344 345.8970642089844 L 144.2785034179688 343.98388671875 C 143.9278106689453 342.0091247558594 143.75 340.0224609375 143.75 338.0790100097656 C 143.75 333.5413513183594 144.6381683349609 329.1406860351562 146.3898620605469 324.9993286132812 C 148.0823059082031 320.9979553222656 150.5057220458984 317.4038391113281 153.5927734375 314.3168029785156 C 156.6798400878906 311.229736328125 160.2739410400391 308.8063049316406 164.2752990722656 307.1138610839844 C 168.4166717529297 305.3621826171875 172.8173370361328 304.4739990234375 177.3549957275391 304.4739990234375 C 181.0115051269531 304.4739990234375 184.6250915527344 305.0671691894531 188.0953826904297 306.2370300292969 L 190.0460815429688 306.8946228027344 L 191.0657501220703 305.1063537597656 C 193.9557800292969 300.0378723144531 198.1338043212891 295.7841796875 203.1481628417969 292.8050537109375 C 208.3103942871094 289.7381286621094 214.2313690185547 288.1170043945312 220.27099609375 288.1170043945312 C 226.3436889648438 288.1170043945312 232.2927856445312 289.7547607421875 237.4750823974609 292.8532409667969 C 242.5103302001953 295.86376953125 246.6927795410156 300.1577758789062 249.5703125 305.2710571289062 L 250.6016998291016 307.1039123535156 L 252.5840301513672 306.4014282226562 C 256.1932067871094 305.1224975585938 259.9701538085938 304.4739990234375 263.8099975585938 304.4739990234375 C 268.34765625 304.4739990234375 272.7483215332031 305.3621826171875 276.8897094726562 307.1138610839844 C 280.8910522460938 308.8063049316406 284.4851684570312 311.229736328125 287.5722351074219 314.3168029785156 C 290.6592712402344 317.4038391113281 293.0827026367188 320.9979553222656 294.775146484375 324.9993286132812 C 296.5268249511719 329.1406860351562 297.4150085449219 333.5413513183594 297.4150085449219 338.0790100097656 C 297.4150085449219 340.0172119140625 297.2371215820312 342.0042724609375 296.8862915039062 343.9849853515625 L 296.5475769042969 345.8974609375 L 298.3169555664062 346.6984558105469 C 304.1274108886719 349.3289489746094 309.0567016601562 353.5417175292969 312.5718994140625 358.8812866210938 C 316.1766357421875 364.35693359375 318.0820007324219 370.7325744628906 318.0820007324219 377.3190002441406 C 318.0820007324219 383.8763427734375 316.1920166015625 390.2284240722656 312.6164245605469 395.6885375976562 C 309.1304931640625 401.01171875 304.2375793457031 405.2245788574219 298.4666748046875 407.8716430664062 L 296.7569580078125 408.6559143066406 L 297.0368347167969 410.5159606933594 C 297.2877502441406 412.183837890625 297.4150085449219 413.8818969726562 297.4150085449219 415.56298828125 C 297.4150085449219 420.1006774902344 296.5268249511719 424.5013122558594 294.775146484375 428.6426696777344 C 293.0827026367188 432.64404296875 290.6592712402344 436.2381896972656 287.5722351074219 439.3252258300781 C 284.4851684570312 442.4122924804688 280.8910522460938 444.835693359375 276.8897094726562 446.5281372070312 C 272.7483215332031 448.2798461914062 268.34765625 449.1679992675781 263.8099975585938 449.1679992675781 C 259.97021484375 449.1679992675781 256.1932373046875 448.5195007324219 252.5840301513672 447.2405700683594 L 250.6016998291016 446.5380859375 L 249.5703125 448.3709411621094 C 246.6927795410156 453.4841918945312 242.5103302001953 457.7782287597656 237.4750823974609 460.7887573242188 C 232.2927856445312 463.8872375488281 226.3436889648438 465.5249938964844 220.27099609375 465.5249938964844 Z"
              stroke="none"
            />
            <path
              d="M 220.27099609375 463.0249938964844 C 225.8920593261719 463.0249938964844 231.3975067138672 461.5097045898438 236.1921844482422 458.6430358886719 C 240.8545074462891 455.85546875 244.7271728515625 451.8794860839844 247.3915863037109 447.1448364257812 C 248.5839080810547 445.026123046875 251.1274566650391 444.0720520019531 253.4190521240234 444.8841247558594 C 256.7593994140625 446.0678405761719 260.2554321289062 446.6679992675781 263.8099975585938 446.6679992675781 C 268.0112609863281 446.6679992675781 272.0842590332031 445.8462829589844 275.9158325195312 444.2256469726562 C 279.6191711425781 442.6592407226562 282.9461975097656 440.4157409667969 285.8044738769531 437.5574645996094 C 288.6627502441406 434.6991882324219 290.90625 431.3721618652344 292.47265625 427.6687927246094 C 294.09326171875 423.8372497558594 294.9150085449219 419.7642822265625 294.9150085449219 415.56298828125 C 294.9150085449219 414.0059814453125 294.797119140625 412.4330749511719 294.5646362304688 410.887939453125 C 294.2331848144531 408.684814453125 295.3993225097656 406.5281982421875 297.4243469238281 405.5993041992188 C 302.7670288085938 403.1486206054688 307.2971496582031 399.2479553222656 310.5249633789062 394.3189392089844 C 313.8332824707031 389.2669677734375 315.5820007324219 383.3884887695312 315.5820007324219 377.3190002441406 C 315.5820007324219 371.2225952148438 313.8190612792969 365.3222961425781 310.4837341308594 360.2559509277344 C 307.2288513183594 355.311767578125 302.6651000976562 351.4111938476562 297.285888671875 348.9759521484375 C 295.2039794921875 348.0334167480469 294.0260620117188 345.79931640625 294.4246215820312 343.5489807128906 C 294.75 341.7118225097656 294.9150085449219 339.8714294433594 294.9150085449219 338.0790100097656 C 294.9150085449219 333.8777160644531 294.09326171875 329.8047485351562 292.47265625 325.9731750488281 C 290.90625 322.2698364257812 288.6627502441406 318.9428100585938 285.8044738769531 316.0845336914062 C 282.9461975097656 313.2262878417969 279.6191711425781 310.9827880859375 275.9158325195312 309.4163513183594 C 272.0842590332031 307.7957458496094 268.0112915039062 306.9739990234375 263.8099975585938 306.9739990234375 C 260.25537109375 306.9739990234375 256.7593688964844 307.5741882324219 253.4190521240234 308.7578735351562 C 251.1273956298828 309.5698547363281 248.5838928222656 308.6158752441406 247.3915863037109 306.4971618652344 C 244.7271728515625 301.7625122070312 240.8545074462891 297.7864990234375 236.1921844482422 294.9989624023438 C 231.3975067138672 292.1322631835938 225.8920593261719 290.6170043945312 220.27099609375 290.6170043945312 C 214.6805572509766 290.6170043945312 209.2011108398438 292.1168518066406 204.4251251220703 294.954345703125 C 199.7821502685547 297.7127990722656 195.9135284423828 301.6515197753906 193.2375335693359 306.3446655273438 C 192.0528869628906 308.4221801757812 189.5629730224609 309.3699340820312 187.2967987060547 308.6060485839844 C 184.0843200683594 307.5231018066406 180.7394104003906 306.9739990234375 177.3549957275391 306.9739990234375 C 173.1537017822266 306.9739990234375 169.0807342529297 307.7957458496094 165.2491760253906 309.4163513183594 C 161.5458221435547 310.9827880859375 158.2187957763672 313.2262878417969 155.3605346679688 316.0845336914062 C 152.5022583007812 318.9428100585938 150.2587585449219 322.2698364257812 148.6923522949219 325.9731750488281 C 147.0717315673828 329.8047485351562 146.25 333.8777160644531 146.25 338.0790100097656 C 146.25 339.8763122558594 146.4148559570312 341.7159118652344 146.7399749755859 343.5467529296875 C 147.1397094726562 345.7976989746094 145.9617919921875 348.0330810546875 143.8791198730469 348.9759521484375 C 138.4997406005859 351.4112854003906 133.935791015625 355.3118896484375 130.6806793212891 360.256103515625 C 127.3450927734375 365.322509765625 125.5820007324219 371.2227783203125 125.5820007324219 377.3190002441406 C 125.5820007324219 383.3883056640625 127.3308258056641 389.2667541503906 130.6394348144531 394.3187866210938 C 133.8675079345703 399.2478332519531 138.3978271484375 403.1485595703125 143.7406463623047 405.5993041992188 C 145.7656707763672 406.5281982421875 146.9318237304688 408.684814453125 146.6003570556641 410.887939453125 C 146.3678894042969 412.4330749511719 146.25 414.0059814453125 146.25 415.56298828125 C 146.25 419.7642822265625 147.0717315673828 423.8372497558594 148.6923522949219 427.6687927246094 C 150.2587585449219 431.3721618652344 152.5022583007812 434.6991882324219 155.3605346679688 437.5574645996094 C 158.2187957763672 440.4157409667969 161.5458221435547 442.6592407226562 165.2491760253906 444.2256469726562 C 169.0807342529297 445.8462829589844 173.1537322998047 446.6679992675781 177.3549957275391 446.6679992675781 C 180.7394409179688 446.6679992675781 184.0843200683594 446.1189270019531 187.2967681884766 445.0359497070312 C 189.5630035400391 444.27197265625 192.0529174804688 445.2197875976562 193.2375335693359 447.2973327636719 C 195.9135284423828 451.990478515625 199.7821502685547 455.9292297363281 204.4251251220703 458.6876525878906 C 209.2011108398438 461.525146484375 214.6805267333984 463.0249938964844 220.27099609375 463.0249938964844 M 220.27099609375 468.0249938964844 C 206.8269958496094 468.0249938964844 195.1080017089844 460.6720275878906 188.8939971923828 449.7739868164062 C 185.2689971923828 450.9960021972656 181.3919982910156 451.6679992675781 177.3549957275391 451.6679992675781 C 157.4149932861328 451.6679992675781 141.25 435.5029907226562 141.25 415.56298828125 C 141.25 413.7210083007812 141.3899993896484 411.9119873046875 141.656005859375 410.1440124511719 C 129.2230072021484 404.4410095214844 120.5820007324219 391.8930053710938 120.5820007324219 377.3190002441406 C 120.5820007324219 362.6820068359375 129.2969970703125 350.0889892578125 141.8170013427734 344.4209899902344 C 141.4510040283203 342.3599853515625 141.25 340.2439880371094 141.25 338.0790100097656 C 141.25 318.1390075683594 157.4149932861328 301.9739990234375 177.3549957275391 301.9739990234375 C 181.3919982910156 301.9739990234375 185.2689971923828 302.6460266113281 188.8939971923828 303.8680114746094 C 195.1080017089844 292.9700012207031 206.8269958496094 285.6170043945312 220.27099609375 285.6170043945312 C 233.7870025634766 285.6170043945312 245.5610046386719 293.0490112304688 251.7490081787109 304.0450134277344 C 255.5220031738281 302.7080078125 259.5790100097656 301.9739990234375 263.8099975585938 301.9739990234375 C 283.75 301.9739990234375 299.9150085449219 318.1390075683594 299.9150085449219 338.0790100097656 C 299.9150085449219 340.2439880371094 299.7130432128906 342.3599853515625 299.3479919433594 344.4209899902344 C 311.8680114746094 350.0889892578125 320.5820007324219 362.6820068359375 320.5820007324219 377.3190002441406 C 320.5820007324219 391.8930053710938 311.9419860839844 404.4410095214844 299.5090026855469 410.1440124511719 C 299.7749938964844 411.9119873046875 299.9150085449219 413.7210083007812 299.9150085449219 415.56298828125 C 299.9150085449219 435.5029907226562 283.75 451.6679992675781 263.8099975585938 451.6679992675781 C 259.5790100097656 451.6679992675781 255.5220031738281 450.9339904785156 251.7490081787109 449.5969848632812 C 245.5610046386719 460.5929870605469 233.7870025634766 468.0249938964844 220.27099609375 468.0249938964844 Z"
              stroke="none"
              fill="#fff"
            />
          </g>
        </svg>
        <div className={list.list_left_img}>
          <img
            src={`/project/${data.no}/${data.project_img1}`}
            style={{ cursor: "pointer" }}
            onClick={() => selectItem(data.no)}
          />
        </div>

        {/* <a>asd</a> */}
      </li>
    );
  };
  const [rightColor, setRightColor] = useState();
  const LiItem = ({ cate }) => {
    const yearClick = (data) => {
      setRightColor(data);
    };
    return (
      <li
        className={
          rightColor === cate.no
            ? `${list.list_right_li} ${list.list_right_color}`
            : `${list.list_right_li}`
        }
        onClick={() => {
          yearClick(cate.no);
        }}
      >
        {cate.category_title}
      </li>
    );
  };

  const LiItem2 = ({ cate }) => {
    const yearClick = (data) => {
      setRightColor(data);
    };
    return (
      <li
        className={
          rightColor === cate.no
            ? `${list.list_right_li} ${list.list_right_color}`
            : `${list.list_right_li}`
        }
        onClick={() => {
          yearClick(cate.no);
        }}
      >
        {cate.category_title}
      </li>
    );
  };
  return (
    <>
      <div id="wrapper">
        <div id="container">
          <div className={list.list}>
            <div className={list.wrap}>
              <div className={list.list_box}>
                <div
                  className={`${list.list_left_div} ${list.list_left_div_block_one}`}
                >
                  {sw && (
                    <>
                      <ul>
                        {" "}
                        <Swiper
                          className="list_swiper"
                          slidesPerView={3}
                          direction={"horizontal"}
                          ref={setSwiper}
                          {...parmss}
                          style={{ height: "560px" }}
                          modules={[Navigation, Grid, Pagination]}
                          breakpoints={{
                            640: {
                              direction: "vertical",
                            },
                          }}
                        >
                          {data1 &&
                            data1.map((data) => {
                              return (
                                <SwiperSlide>
                                  <SwiperItem data={data} />
                                </SwiperSlide>
                              );
                            })}
                        </Swiper>
                      </ul>{" "}
                      <div
                        className={`${list.list_left_arrow} ${list.list_arrow_up} ${list.list_block}`}
                        ref={prevRef}
                      >
                        <BiSolidUpArrow />
                      </div>
                      <div
                        className={`${list.list_left_arrow} ${list.list_arrow_down} ${list.list_block}`}
                        ref={nextRef}
                      >
                        <BiSolidDownArrow />
                      </div>
                    </>
                  )}
                </div>{" "}
                <div
                  className={`${list.list_left_div} ${list.list_left_div_block}`}
                >
                  {sw && (
                    <>
                      <div
                        className={`${list.list_left_arrow_div} ${list.list_arrow_up_div} `}
                        ref={prevRef1}
                      >
                        <BiSolidLeftArrow />
                      </div>{" "}
                      <div
                        className={`${list.list_left_arrow_div} ${list.list_arrow_down_div} `}
                        ref={nextRef1}
                      >
                        <BiSolidRightArrow />
                      </div>
                      <ul>
                        {" "}
                        <Swiper
                          className="list_swiper"
                          slidesPerView={3}
                          direction={"horizontal"}
                          ref={setSwiper1}
                          {...parmss1}
                          style={{ height: "560px" }}
                          modules={[Navigation, Grid, Pagination]}
                        >
                          {data1 &&
                            data1.map((data) => {
                              return (
                                <SwiperSlide>
                                  <SwiperItem data={data} />
                                </SwiperSlide>
                              );
                            })}
                        </Swiper>
                      </ul>{" "}
                    </>
                  )}
                </div>
                {select && sw && (
                  <>
                    <div className={list.list_right_div}>
                      {" "}
                      <div className={list.list_right_year}>
                        {category.length > 0 && category.length > 1 && (
                          <ul className={list.ul_first}>
                            {category.length > 0 &&
                              category.length > 1 &&
                              category.map((data) => {
                                return <LiItem cate={data} />;
                              })}
                          </ul>
                        )}
                        {category.length > 0 && category.length === 1 && (
                          <ul className={list.ul_second}>
                            {category.length > 0 && category.length === 1 && (
                              <LiItem2 cate={category[0]} />
                            )}
                          </ul>
                        )}
                      </div>{" "}
                      <div className={list.list_right_wrap}>
                        {rightColor && select && (
                          <ListContent
                            select={select}
                            rightColor={rightColor}
                          />
                        )}
                      </div>
                    </div>{" "}
                  </>
                )}
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default ListWrap;
